import { RoleType } from 'types/staff'
import { Action, Dispatch } from 'redux'
import { SwitchingStoreRefType } from 'types/auth'
import { FirebaseDocRefType } from 'firebase/index'
import { fetchSwitchingStoreRefsAction, switchStoreRefAction } from 'reducks/auth/actions'
import { fetchShopRefOfStore, initRootState } from 'reducks/auth/operations'
import { MELLOW_SHOP_ID, MELLOW_SHOP_REF } from 'constants/shop'

const fetchSwitchingStoreRefs = (roles: RoleType[]) => {
  return async (dispatch: Dispatch<Action>) => {
    const switchingStoreRefs: SwitchingStoreRefType[] = []
    roles.map((role) => {
      switchingStoreRefs.push({
        store_ref: role.store_ref,
        manufacturer_ref: undefined,
        is_event_staff: false,
      })
    })

    dispatch(fetchSwitchingStoreRefsAction(switchingStoreRefs))
    // TODO Marché Bakery スタッフを初期状態にするため
    const promises = []
    for (let i = 0; i < switchingStoreRefs.length; i = (i + 1) | 0) {
      const { store_ref } = switchingStoreRefs[i]
      promises.push(fetchShopRefOfStore(store_ref))
    }
    try {
      const result: Array<FirebaseDocRefType | undefined> = await Promise.all(promises)
      const refs = result.filter((ref) => typeof ref !== 'undefined') as FirebaseDocRefType[]
      const duplicatedRefs = refs.filter((ref) => refs.some((_ref) => _ref.id === ref.id))
      // TODO 店舗横断モードを共通化するときはshop_idの制限を外す
      if (!duplicatedRefs.some((ref) => ref.id === MELLOW_SHOP_ID)) return
      dispatch(switchStoreRefAction({ role: 9, brandRef: undefined, shopRef: undefined, storeRef: MELLOW_SHOP_REF }))
      initRootState(dispatch)
    } catch (e) {
      console.error(e)
    }
  }
}

export default fetchSwitchingStoreRefs
